// src/components/PublicationNote.jsx
//
// Discreet single-line publication-time note (spec section 6 of the
// 2026-08-25 price-forecast expansion brief): for a market x product, states
// when the forecast is published and when the actuals are published. Muted
// caption under a panel header - theme tokens only, no layout shift, no
// hardcoded colors. Renders nothing when no entry exists for the pair.
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { getPublicationNote } from "../constants/publicationTimes";

export default function PublicationNote({ product, market, sx }) {
  const entry = getPublicationNote(product, market);
  if (!entry) return null;
  const parts = [];
  if (entry.forecast) parts.push(`Forecast published ${entry.forecast}`);
  if (entry.actuals) parts.push(`Actuals: ${entry.actuals}`);
  return (
    <Box sx={{ mt: 0.25, mb: 0.75, ...sx }}>
      <Typography
        variant="caption"
        sx={{ color: "text.secondary", display: "block", lineHeight: 1.4 }}
      >
        {parts.join(" · ")}
      </Typography>
    </Box>
  );
}
